import React, { memo } from 'react';
import * as async from '../helpers';
export var AsyncViewContainer = memo(function AsyncViewWrapper2(_a) {
  var asyncData = _a.asyncData,
      inProgressRender = _a.inProgressRender,
      _b = _a.setInProgressRenderBeforeChildren,
      setInProgressRenderBeforeChildren = _b === void 0 ? false : _b,
      forceInProgress = _a.forceInProgress,
      errorRender = _a.errorRender,
      _c = _a.setErrorRenderBeforeChildren,
      setErrorRenderBeforeChildren = _c === void 0 ? false : _c,
      forceError = _a.forceError,
      children = _a.children;
  var inProgress = forceInProgress || (Array.isArray(asyncData) ? async.isAnyInProgressOrInvalidated.apply(async, asyncData) : async.isInProgressOrInvalidated(asyncData));
  var error = forceError || (Array.isArray(asyncData) ? asyncData.filter(async.isError).map(function (ad) {
    return ad.error;
  }) : async.getError(asyncData));
  return React.createElement(React.Fragment, null, error && (!Array.isArray(error) || error.length > 0) && errorRender && setErrorRenderBeforeChildren ? errorRender(error) : null, inProgress && inProgressRender && setInProgressRenderBeforeChildren ? inProgressRender() : null, children, inProgress && inProgressRender && !setInProgressRenderBeforeChildren ? inProgressRender() : null, error && (!Array.isArray(error) || error.length > 0) && errorRender && setErrorRenderBeforeChildren ? errorRender(error) : null);
});